import React from "react";
import { HashLink } from "react-router-hash-link";

const NavLinks = () => {
  return (
    <>
      <HashLink
        className="px-4 font-extrabold text-gray-500 hover:text-blue-900 text-lg"
        smooth
        to={encodeURI("/")}
      >
        首頁
      </HashLink>

      <HashLink
        className="px-4 font-extrabold text-gray-500 hover:text-blue-900 text-lg"
        to={encodeURI("/奧斯汀美語-桃園安親班")}
      >
        幼兒園
      </HashLink>

      <HashLink
        className="px-4 font-extrabold text-gray-500 hover:text-blue-900 text-lg"
        smooth
        to={encodeURI("/奧斯汀美語-兒童美語")}
      >
        兒童美語
      </HashLink>

      <HashLink
        className="px-4 font-extrabold text-gray-500 hover:text-blue-900 text-lg"
        to={encodeURI("/奧斯汀美語-暑假-國小課輔班")}
      >
        國小課輔班
      </HashLink>

      <HashLink
        className="px-4 font-extrabold text-gray-500 hover:text-blue-900 text-lg"
        to={encodeURI("/奧斯汀美語-文化分校-地址")}
      >
        {"文化分校(桃園市平鎮區)"}
      </HashLink>

      <HashLink
        className="px-4 font-extrabold text-gray-500 hover:text-blue-900 text-lg"
        to={encodeURI("/奧斯汀美語-心象文理補習班-地址")}
      >
        {"心象分校(新北市新店區)"}
      </HashLink>
    </>
  );
};

export default NavLinks;
